'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AngleRight;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function AngleRight(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      className: 'icon-svg-angle-right ' + className,
      focusable: 'false',
      'aria-hidden': true,
      width: width,
      height: height,
      viewBox: '0 0 8 14' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M8,1.16432866 C8,1.27655311 7.94501718,1.40280561 7.86254296,1.48697395 L2.4604811,7 L7.86254296,12.5130261 C7.94501718,12.5971944 8,12.7234469 8,12.8356713 C8,12.9478958 7.94501718,13.0741483 7.86254296,13.1583166 L7.17525773,13.8597194 C7.09278351,13.9438878 6.96907216,14 6.85910653,14 C6.74914089,14 6.62542955,13.9438878 6.54295533,13.8597194 L0.137457045,7.32264529 C0.0549828179,7.23847695 0,7.11222445 0,7 C0,6.88777555 0.0549828179,6.76152305 0.137457045,6.67735471 L6.54295533,0.140280561 C6.62542955,0.0561122244 6.74914089,0 6.85910653,0 C6.96907216,0 7.09278351,0.0561122244 7.17525773,0.140280561 L7.86254296,0.841683367 C7.94501718,0.925851703 8,1.03807615 8,1.16432866 Z', transform: 'matrix(-1 0 0 1 8 0)' })
  );
}

AngleRight.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Angle/Right.js
// module id = 118
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15